import classNames from 'classnames';

import { policyWrapper } from '../../../../styles/PolicyStyles';

const PrivacyPolicy_v2 = (): JSX.Element => {
  return (
    <article css={policyWrapper}>
      <p className="f13 c_gray">
        (주)큐딜리온(이하 &quot;회사&quot; 또는 &quot;큐딜리온&quot;이라 함)은
        회사가 운영하는 인터넷 사이트 및 모바일 애플리케이션(이하
        &apos;중고나라&apos;라 함)을 이용하는 이용자님들의 개인정보를 매우
        중요하게 생각하며, 통신비밀보호법, 전기통신사업법, 정보통신망 이용촉진
        및 정보보호 등에 관한 법률 등 정보통신서비스제공자가 준수하여야 할 관련
        법령상의 개인정보보호 규정을 준수하고, 관련 법령에 의거한 개인정보
        취급방침을 정하여 이용자 권익 보호에 최선을 다하고 있습니다.
      </p>
      <dl
        className={classNames(
          'f13',
          'c_gray',
          'mt20',
          'list_desc',
          'termsCont',
        )}
      >
        <dt className="relative pd_l20 mt10">
          <span className="desc">
            <strong>1.</strong>
          </span>
          <p>
            <strong>개인정보의 항목</strong>
          </p>
        </dt>
        <dd className="mt10">
          <p>
            가. ‘회사’는 회원가입시 본인확인, 원활한 고객상담, 각종 서비스의
            제공을 위해 최초 회원가입 당시 아래와 같은 개인정보를 수집하고
            있습니다.
          </p>
          <table className={classNames('mt10', 'termsTable')}>
            <thead>
              <tr>
                <th className={'w30'}>
                  <p>구분</p>
                </th>
                <th className={'w70'}>
                  <p>이용 목적</p>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <p>회원관리</p>
                </td>
                <td>
                  <p>회원제 서비스 이용에 따른 회원식별</p>
                  <p>불량회원의 부정이용 방지와 중복가입방지</p>
                  <p>가입의사 확인</p>
                  <p>미성년자의 확인</p>
                  <p>회원문의, 불만 접수 및 처리, 분쟁조정을 위한 기록보존</p>
                  <p>고지사항 전달</p>
                  <p>부정거래 방지</p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>
                    서비스 제공에 관한 계약의 이행 및 서비스 제공에 대한 수집
                  </p>
                </td>
                <td>
                  <p>회원간 거래 서비스 제공</p>
                  <p>콘텐츠 제공, 이벤트/경품당첨 결과안내 및 상품배송</p>
                  <p>금융거래 관련 본인인증 및 금융서비스</p>
                  <p>부정거래 방지</p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>마케팅 및 광고에 활용( 이용동의 대상기준 )</p>
                </td>
                <td>
                  <p>최적화된 서비스 제공</p>
                  <p>새로운 상품 또는 서비스 안내</p>
                  <p>회원 관심사에 부합하는 서비스 및 이벤트 기획</p>
                  <p>서비스 및 상품 안내</p>
                </td>
              </tr>
            </tbody>
          </table>
        </dd>
        <dt className="relative pd_l20 mt10">
          <span className="desc">
            <strong>2.</strong>
          </span>
          <p>
            <strong>수집하는 개인정보의 이용 목적</strong>
          </p>
        </dt>
        <dd className="mt10">
          <table className={classNames('mt10', 'termsTable')}>
            <thead>
              <tr>
                <th className={'w25'}>
                  <p>유형</p>
                </th>
                <th className={'w25'}>
                  <p>구분</p>
                </th>
                <th className={'w25'}>
                  <p>수집/이용 항목</p>
                </th>
                <th className={'w25'}>
                  <p>수집/이용 목적</p>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td rowSpan={5}>
                  <p>필수(회원가입 및 부정이용방지 등 필수적인 정보)</p>
                </td>
                <td rowSpan={4}>
                  <p>회원공통</p>
                </td>
                <td>
                  <p>
                    이름, 생년월일, 아이디, 비밀번호, 휴대전화번호,
                    중복가입번호(DI), 연계정보(CI), 광고식별자(ADID/IDFA),
                    방문식별자(UUID), 말기 정보 (단말기 명, OS, 앱 버전),
                    법정대리인 정보(만 14세 미만 가입시에만 해당)
                  </p>
                </td>
                <td>
                  <p>
                    이용자 식별, 거래이행을 위한 연락, 서비스 이용에 따른 정보
                    제공(고지사항 전달, 본인의사 확인, 서비스관련상담, 민원사항
                    처리, 유의사항 등)
                  </p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>
                    성명, 아이디(ID), 이메일(E-mail), 주소, 휴대전화번호,
                    서비스이용기록, 아이피 주소(IP address), 접속로그
                  </p>
                </td>
                <td>
                  <p>부정거래 방지</p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>
                    자동수집정보: 서비스이용기록, 이용정지기록, 이용해지 기록,
                    아이피 주소(IP address), 접속로그, 쿠키(cookie)
                  </p>
                </td>
                <td>
                  <p>
                    불법/부정이용 방지, 개인정보 유효기간제 준수, 최근 본 상품
                    등 서비스
                  </p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>전화번호, 이메일(E-mail), 주소, SMS, SNS</p>
                </td>
                <td>
                  <p>친구초대, 이벤트 및 알림정보 등 마케팅 활용</p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>계좌등록회원</p>
                </td>
                <td>
                  <p>계좌번호</p>
                </td>
                <td>
                  <p>거래대금 입금 및 환불처리</p>
                </td>
              </tr>
              <tr>
                <td rowSpan={4}>
                  <p>필수(회원간 거래 등 서비스 이용 시 필수적인 정보)</p>
                </td>
                <td rowSpan={4}>
                  <p>회원공통</p>
                </td>
                <td>
                  <p>이름, 수령인, 연락처, 배송지주소, 사진</p>
                </td>
                <td>
                  <p>
                    상품 및 경품 배송(반품/환불), 배송지 및 연락처 확인,
                    상품등록, 서비스관련상담, 민원사항 처리, 최초 입력 후
                    불러오기 기능 제공
                  </p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>계좌주명, 계좌번호</p>
                </td>
                <td>
                  <p>
                    대금결제 서비스, 구매취소 , 서비스관련상담, 민원사항 처리
                    등에 따른 거래금액 환불, 전자금융기록 보관
                  </p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>
                    성명, 생년월일, 성별, 휴대전화번호(휴대폰 인증시),
                    CI(연계정보), DI(중복정보), IP, 위치정보
                  </p>
                </td>
                <td>
                  <p>
                    서비스 이용을 위한 이용자 식별, 최초본인인증 시 정보 자동
                    업데이트, 회원 연령확인, 거래 안전을 위해 본인인증 후
                    구매하거나 이용할 수 있는 서비스, 아이디(ID) 보유여부 확인,
                    거래안전 및 편법행위 방지
                  </p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>수취인 성명, 수취인 연락처, 수취인 주소</p>
                </td>
                <td>
                  <p>부정거래 방지</p>
                </td>
              </tr>
            </tbody>
          </table>
        </dd>
        <dt className="relative pd_l20 mt10">
          <span className="desc">
            <strong>3.</strong>
          </span>
          <p>
            <strong>개인정보 제 3자 제공</strong>
          </p>
        </dt>
        <dd className="mt10">
          <ul className="list_desc">
            <li className="pd_l20">
              <span className="desc">가.</span>
              <p>
                회사는 이용자들의 개인정보를 「1. 개인정보의 수집 및 이용」에서
                고지한 범위 내에서 사용하며, 이용자의 사전 동의 없이 동 범위를
                초과하여 이용하거나 원칙적으로 이용자의 개인정보를 제3자에게
                제공하지 않습니다. 다만, 아래의 경우에는 예외로 합니다.
              </p>
              <ul className="list_desc mt5">
                <li className="pd_l20">
                  <span className="desc">①</span>
                  <p>이용자들이 사전에 공개 또는 제 3자 제공에 동의한 경우</p>
                </li>
                <li className="pd_l20">
                  <span className="desc">②</span>
                  <p>
                    &apos;중고나라&apos;의 이용약관을 위배하거나
                    &apos;중고나라&apos;의 &apos;서비스&apos;를 이용하여
                    타인에게 피해를 주거나 미풍양속을 해치는 위법행위를 한 사람
                    등에게 법적인 조치를 취하기 위해 개인 정보를 공개해야 한다고
                    판단되는 경우
                  </p>
                </li>
                <li className="pd_l20">
                  <span className="desc">③</span>
                  <p>
                    법령의 규정에 의거하거나, 수사, 조사 목적으로 법령에 정해진
                    절차와 방법에 따라 수사기관 및 감독당국의 요구가 있는 경우
                  </p>
                </li>
              </ul>
            </li>
          </ul>
        </dd>
        <dt className="relative pd_l20 mt10">
          <span className="desc">
            <strong>4.</strong>
          </span>
          <p>
            <strong>개인정보의 보유 및 이용기간</strong>
          </p>
        </dt>
        <dd className="mt10">
          <p>
            회사는 원칙적으로 회원의 개인정보를 회원탈퇴 시 지체 없이
            파기합니다. 다만, 회사 내부 방침에 따라 회원에게 미리 고지하고 동의
            받았거나 별도의 법령에서 정한 경우에는 그 기간동안 안전하게
            보관하며, 절대 다른 목적으로 이용하지 않습니다.
          </p>
          <ul className="list_desc">
            <li className="pd_l20">
              <span className="desc">가.</span>
              <p>회사 내부 방침에 따라 보관하는 정보는 다음과 같습니다. </p>
              <ul className="list_desc mt5">
                <li className="pd_l20">
                  <span className="desc">-</span>
                  <p>비정상적인 회원탈퇴 등으로 인한 보관</p>
                  <p>보존 기간 : 회원탈퇴 신청 후 7일</p>
                </li>
                <li className="pd_l20">
                  <span className="desc">-</span>
                  <p>
                    임의탈퇴를 반복적으로 행하는 등 회사가 제공하는 등업신청,
                    이벤트 참여 등 비정상적 인 방법으로 이익을 편법적으로
                    이용하는 행위 차단
                  </p>
                  <p>보존 기간 : 회원탈퇴 신청 후 30일 </p>
                </li>

                <li className="pd_l20">
                  <span className="desc">-</span>
                  <p>부정 이용기록</p>
                  <p>보존 이유 : 부정 이용 방지</p>
                  <p>보존 기간: 6개월</p>
                </li>
                <li className="pd_l20">
                  <span className="desc">-</span>
                  <p>사기예방을 위해 필요한 기록 </p>
                  <p>보존 이유: 사기 예방</p>
                  <p>보존 기간: 3년</p>
                </li>
              </ul>
            </li>
            <li className="pd_l20">
              <span className="desc">나.</span>
              <p>관련법령에 의한 정보보유 사유</p>
              <p>
                상법, 전자상거래 등에서의 소비자보호에 관한 법률 등 관계법령의
                규정에 의하여 보존할 필요가 있는 경우 회사는 관계법령에서 정한
                일정한 기간 동안 회원정보를 보관합니다. 이 경우 회사는 보관하는
                정보를 그 보관의 목적으로만 이용하며 보존기간은 아래와 같습니다.
              </p>
              <ul className="list_desc mt5">
                <li className="pd_l20">
                  <span className="desc">-</span>
                  <p>계약 또는 청약철회 등에 관한 기록</p>
                  <p>보존 이유: 전자상거래 등에서의 소비자보호에 관한 법률</p>
                  <p>보존 기간: 5년</p>
                </li>
                <li className="pd_l20">
                  <span className="desc">-</span>
                  <p>대금결제 및 재화 등의 공급에 관한 기록</p>
                  <p>보존 이유: 전자상거래 등에서의 소비자보호에 관한 법률</p>
                  <p>보존 기간: 5년</p>
                </li>
                <li className="pd_l20">
                  <span className="desc">-</span>
                  <p>소비자의 불만 또는 분쟁처리에 관한 기록</p>
                  <p>보존 이유: 전자상거래 등에서의 소비자보호에 관한 법률</p>
                  <p>보존 기간: 3년</p>
                </li>
                <li className="pd_l20">
                  <span className="desc">-</span>
                  <p>본인확인에 관한 기록</p>
                  <p>
                    보존 이유: 정보통신망 이용촉진 및 정보보호 등에 관한 법률
                  </p>
                  <p>보존 기간: 6개월</p>
                </li>
                <li className="pd_l20">
                  <span className="desc">-</span>
                  <p>방문에 관한 기록</p>
                  <p>보존 이유: 통신비밀보호법</p>
                  <p>보존 기간: 3개월</p>
                </li>
              </ul>
            </li>
            <li className="pd_l20">
              <span className="desc">다.</span>
              <p>
                1년 이상 서비스 이용 기록이 없는 회원의 정보는 ‘정보통신망
                이용촉진 및 정보보호 등에 관한 법률’의 ‘개인정보 유효기간제’
                적용에 따라 탈퇴 처리됩니다. 장기간(1년 이상) 서비스 미이용자의
                경우 개인정보보호를 위하여 별도로 DB에 분리하여 저장, 관리되며
                이후 내부 방침 및 기타 관련 법령에 의한 정보보호 사유에 따라
                일정 기간 저장된 후 파기되어 집니다.
              </p>
            </li>
            <li className="pd_l20">
              <span className="desc">라.</span>
              <p>
                휴면계정 전환 최소 30일 전, 등록된 전화번호 혹은 이메일 통해
                전환 예정 일자를 안내하고 전환을 원하지 않는 경우, 안내 확인 후
                로그인 하면 정상 서비스 이용 가능합니다.
              </p>
            </li>
          </ul>
        </dd>
        <dt className="relative pd_l20 mt10">
          <span className="desc">
            <strong>5.</strong>
          </span>
          <p>
            <strong>이용자의 권리</strong>
          </p>
        </dt>
        <dd className="mt10">
          <p>
            &apos;회원&apos;은 언제든지 본인의 개인정보를 열람 및 정정 삭제할 수
            있습니다. &apos;회원&apos;이 입력한 부정확한 정보로 인해 발생하는
            사고의 책임은 본인에게 있으며 타인 정보의 도용 등 허위정보를 입력할
            경우 회원자격이 상실될 수 있습니다.
          </p>
        </dd>
        <dt className="relative pd_l20 mt10">
          <span className="desc">
            <strong>6.</strong>
          </span>
          <p>
            <strong>개인정보 파기 절차 및 방법</strong>
          </p>
        </dt>
        <dd className="mt10">
          <ul className="list_desc mt10">
            <li className="pd_l20 mt10">
              <span className="desc">가.</span>
              <p>파기절차</p>
              <ul className="list_desc mt5">
                <li className="pd_l20">
                  <span className="desc">①</span>
                  <p>
                    이용자가 회원가입 등을 위해 입력한 정보는 목적이 달성된 후
                    별도의 DB로 옮겨져(종이의 경우 별도의 서류함) 내부 방침 및
                    기타 관련 법령에 의한 정보보호 사유에 따라(보유 및 이용기간
                    참조)일정 기간 저장된 후 파기됩니다.
                  </p>
                </li>
                <li className="pd_l20 mt5">
                  <span className="desc">②</span>
                  <p>
                    동 개인정보는 법률에 의한 경우가 아니고서는 보유되는 이외의
                    다른 목적으로 이용되지 않습니다.
                  </p>
                </li>
              </ul>
            </li>
            <li className="pd_l20 mt10">
              <span className="desc">나.</span>
              <p>파기방법</p>
              <ul className="list_desc mt5">
                <li className="pd_l20">
                  <span className="desc">①</span>
                  <p>
                    종이에 출력된 개인정보는 분쇄기로 분쇄하거나 소각을 통하여
                    파기합니다.
                  </p>
                </li>
                <li className="pd_l20 mt5">
                  <span className="desc">②</span>
                  <p>
                    전자적 파일 형태로 저장된 개인정보는 기록을 재생할 수 없는
                    기술적 방법을 사용하여 삭제합니다.
                  </p>
                </li>
              </ul>
            </li>
          </ul>
        </dd>
        <dt className="relative pd_l20 mt10">
          <span className="desc">
            <strong>7.</strong>
          </span>
          <p>
            <strong>링크 사이트에 대한 책임</strong>
          </p>
        </dt>
        <dd className="mt10">
          <p>
            &apos;회사&apos;는 &apos;이용자&apos;에게 다른 웹사이트에 대한
            링크를 제공할 수 있습니다. 이 경우 &apos;회사&apos;는 외부사이트 및
            자료에 대한 아무런 통제권이 없으므로 그로부터 제공받는 서비스나
            자료의 진실성, 유용성 등에 대해서는 당사자간 귀책사항으로
            &apos;회사&apos;는 어떠한 책임도 지지 않으며, 어떠한 보증도 하지
            않습니다. 또한 링크되어 있는 웹사이트들이 개인정보를 수집하는 행위에
            대해서는 본 &quot;개인정보취급방침&quot;이 적용되지 않으므로 새로
            방문한 사이트의 정책을 반드시 검토해 보시기 바랍니다.
          </p>
        </dd>
        <dt className="relative pd_l20 mt10">
          <span className="desc">
            <strong>8.</strong>
          </span>
          <p>
            <strong>개인정보의 기술적/관리적 보호 대책</strong>
          </p>
        </dt>
        <dd className="mt10">
          <p>
            회사는 이용자들의 개인정보를 취급함에 있어 개인정보가 분실, 도난,
            누출, 변조 또는 훼손되지 않도록 안전성 확보를 위하여 다음과 같은
            기술적/관리적 대책을 강구하고 있습니다.
          </p>
          <ul className="list_desc">
            <li className="pd_l20">
              <span className="desc">가.</span>
              <p>해킹 등에 대비한 대책</p>
              <p>
                회사는 해킹이나 컴퓨터 바이러스 등에 의해 회원의 개인정보가
                유출되거나 훼손되는 것을 막기 위해 최선을 다하고 있습니다.
                개인정보의 훼손에 대비해서 자료를 수시로 백업하고 있고, 최신
                백신프로그램을 이용하여 이용자들의 개인정보나 자료가 누출되거나
                손상되지 않도록 방지하고 있으며, 암호화통신 등을 통하여
                네트워크상에서 개인정보를 안전하게 전송할 수 있도록 하고
                있습니다. 그리고 침입차단시스템을 이용하여 외부로부터의 무단
                접근을 통제하고 있으며, 기타 시스템적으로 보안성을 확보하기 위한
                가능한 모든 기술적 장치를 갖추려 노력하고 있습니다.
              </p>
            </li>
            <li className="pd_l20">
              <span className="desc">나.</span>
              <p>취급 직원의 최소화 및 교육</p>
              <p>
                회사의 개인정보관련 취급 직원은 담당자에 한정시키고 있고 이를
                위한 별도의 비밀번호를 부여하여 정기적으로 갱신하고 있으며,
                담당자에 대한 수시 교육을 통하여 회사는 개인정보취급방침의
                준수를 항상 강조하고 있습니다.
              </p>
            </li>
            <li className="pd_l20">
              <span className="desc">다.</span>
              <p>개인정보보호전담기구의 운영</p>
              <p>
                그리고 사내 개인정보보호전담기구 등을 통하여 회사는
                개인정보취급방침의 이행사항 및 담당자의 준수여부를 확인하여
                문제가 발견될 경우 즉시 수정하고 바로 잡을 수 있도록 노력하고
                있습니다. 단, 이용자 본인의 부주의나 인터넷상의 문제로 개인
                정보가 유출되어 발생한 문제에 대해 회사는 일체의 책임을 지지
                않습니다.
              </p>
            </li>
          </ul>
        </dd>
        <dt className="relative pd_l20 mt10">
          <span className="desc">
            <strong>9.</strong>
          </span>
          <p>
            <strong>쿠키(Cookie)의 운용 및 거부</strong>
          </p>
        </dt>
        <dd className="mt10">
          <ul className="list_desc">
            <li className="pd_l20">
              <span className="desc">가.</span>
              <p>
                쿠키의 사용 목적가.&apos;회사&apos;는 개인 맞춤 서비스를
                제공하기 위해서 &apos;이용자&apos;에 대한 정보를 저장하고 수시로
                불러오는 &apos;쿠키(cookie)&apos;를 사용합니다. 쿠키는
                &apos;중고나라&apos; 서버가 이용자의 브라우저에게 전송하는
                소량의 정보로서 &apos;이용자&apos; 컴퓨터의 하드디스크에
                저장됩니다.나. 회사는 쿠키의 사용을 통해서만 가능한 특정된
                맞춤형 서비스를 제공할 수 있습니다.
              </p>
            </li>
            <li className="pd_l20">
              <span className="desc">나.</span>
              <p>
                회사는 회원을 식별하고 회원의 로그인 상태를 유지하기 위해 쿠키를
                사용할 수 있습니다.
              </p>
            </li>
            <li className="pd_l20">
              <span className="desc">다.</span>
              <p>
                쿠키의 설치/운용 및 거부가.&apos;이용자&apos;는 쿠키 설치에 대한
                선택권을 가지고 있습니다. 따라서 &apos;이용자&apos;는 웹
                브라우저에서 옵션을 조정함으로써 모든 쿠키를 허용/거부하거나,
                쿠키가 저장될 때마다 확인을 거치도록 할 수 있습니다.
              </p>
            </li>
            <li className="pd_l20">
              <span className="desc">라.</span>
              <p>
                쿠키의 저장을 거부할 경우에는 개인 맞춤서비스 등
                &apos;회사&apos;가 제공하는 일부 서비스는 이용이 어려울 수
                있습니다.
              </p>
            </li>
          </ul>
        </dd>
        <dt className="relative pd_l20 mt10">
          <span className="desc">
            <strong>10.</strong>
          </span>
          <p>
            <strong>이용자의 의무</strong>
          </p>
        </dt>
        <dd className="mt10">
          <p>
            &apos;회원&apos;은 스스로 개인정보를 보호하고 타인의 정보를 침해하지
            않을 의무도 가지고 있습니다. 비밀번호를 포함한 개인정보가 유출되지
            않도록 주의를 필요로 하고 게시물을 포함한 타인의 개인정보를 훼손하지
            않도록 유의해야 합니다. 만약 이 같은 책임을 다하지 못하고 타인의
            정보를 훼손할 시에는『정보통신망 이용촉진 및 정보보호 등에 관한
            법률』등에 의해 처벌받을 수 있습니다.
          </p>
        </dd>
        <dt className="relative pd_l20 mt10">
          <span className="desc">
            <strong>11.</strong>
          </span>
          <p>
            <strong>개인정보 관리 책임자</strong>
          </p>
        </dt>
        <dd className="mt10">
          <p>
            &apos;회사&apos;는 정보통신부 지정 개인정보지침에 의거 관리책임자 및
            담당부서를 아래와 같이 지정합니다.
          </p>
          <ul className="list_desc mt10">
            <li className="pd_l20">
              <span className="desc">가.</span>
              <p>개인정보관리책임자</p>

              <ul className="list_desc mt5">
                <li className="pd_l10">
                  <span className="desc">-</span>
                  <p>이름: 권오현</p>
                </li>
                <li className="pd_l10 mt5">
                  <span className="desc">-</span>
                  <p>직급: 실장</p>
                </li>
                <li className="pd_l10 mt5">
                  <span className="desc">-</span>
                  <p>전화번호: 070-5066-2278</p>
                </li>
                <li className="pd_l10 mt5">
                  <span className="desc">-</span>
                  <p>이메일: joongna@qdillion.com</p>
                </li>
              </ul>
            </li>
            <li className="pd_l20 mt10">
              <span className="desc">나.</span>
              <p>
                기타 개인정보침해에 대한 신고나 상담이 필요하신 경우에는 아래
                기관에 문의하시기 바랍니다.
              </p>

              <ul className="list_desc mt5">
                <li className="pd_l10">
                  <span className="desc">-</span>
                  <p>개인정보침해신고센터 (www.118.or.kr / 118)</p>
                </li>
                <li className="pd_l10 mt5">
                  <span className="desc">-</span>
                  <p>
                    정보보호마크인증위원회 (www.eprivacy.or.kr / 02-580-0533~4)
                  </p>
                </li>
                <li className="pd_l10 mt5">
                  <span className="desc">-</span>
                  <p>
                    대검찰청 첨단범죄수사과 (http://www.spo.go.kr /
                    02-3480-2000)
                  </p>
                </li>
                <li className="pd_l10 mt5">
                  <span className="desc">-</span>
                  <p>
                    경찰청 사이버테러대응센터 (www.ctrc.go.kr / 02-392-0330)
                  </p>
                </li>
              </ul>
            </li>
          </ul>
        </dd>
        <dt className="relative pd_l20 mt10">
          <span className="desc">
            <strong>12.</strong>
          </span>
          <p>
            <strong>고지의 의무 </strong>
          </p>
        </dt>
        <dd className="mt10">
          <p>
            현 개인정보처리방침은 2018년 03월 19일에 제정되었으며
            개인정보처리방침 내용이 변경되는 경우, 중고나라 APP의 ‘공지사항’란을
            통해 알릴 것입니다.
          </p>
        </dd>
      </dl>
    </article>
  );
};

export default PrivacyPolicy_v2;
